<template>
  <div>
    <div class="table">
      <!--=========查询模块================-->
      <div class="container">
        <div class="handle-box">
          <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px">
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item :label="$t('sys.userList.userName')" prop="name">
                  <el-input class="handle-input" v-model="queryCondition.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('sys.userList.userCd')" prop="userCd">
                  <el-input class="handle-input" v-model="queryCondition.userCd"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-button type="primary" @click="queryData(1)">{{$t('common.search')}}</el-button>
                <el-button type="primary" @click="restQueryForm">{{$t('common.reset')}}</el-button>
                <el-button type="primary" @click="pickUp">{{$t('common.confirm')}}</el-button>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!--=========查询模块END================-->
        <!--=========用户信息数据列表================-->
        <el-table :data="tableData" ref="pickUserTable" row-key="tmUserId" border highlight-current-row>
          <el-table-column :label="$t('common.select')" align="center" width="55">
            <template slot-scope="scope">
              <el-radio v-model="selectDataAll" :label="scope.row.tmUserId" @change="radioChange">{{scope.row.tmUserId}}</el-radio>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="name" :label="$t('sys.userList.userName')"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="emplid" :label="$t('sys.userList.userCd')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="email" :label="$t('sys.userList.email')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="phone" :label="$t('sys.userList.phone')"></el-table-column>
        </el-table>
        <div class="pagination">
          <!--===分页组件===-->
          <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
          </el-pagination>
        </div>
      </div>
      <!--=========用户信息数据列表END================-->
    </div>
  </div>
</template>
<script>
import { userService } from "@/api/user-manage/user";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";

export default {
  name: 'pickupUser',
  props: ['paramInfo'],
  data() {
    return {
      tableData: [],
      selectedId: this.value,
      selectDataAll: null,
      totalCount: 0,
      labelPosition: 'right',
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        name: '',
        userCd: ''
      },
      tmUserId: "",
      taskId: "",
      bizId: "",
    }
  },
  watch: {
    paramInfo: {
      handler(newV, oldV) {
        console.log("🚀 ~ file: transferUser.vue:83 ~ handler ~ newV:", JSON.parse(newV))
        if (newV) {
          this.taskId = JSON.parse(newV).taskId
          this.bizId = JSON.parse(newV).bizId
        }
        this.queryData()
      },
      immediate: true
    },
  },
  mounted() {
    this.queryData()
  },
  methods: {
    queryData() {
      userService.getUserListForStoreFeedbackBasic(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      })
    },
    radioChange(e) {
      console.log("🚀 ~ file: transferUser.vue:104 ~ radioChange ~ e:", e)
      this.tmUserId = e
    },
    pickUp() {
      console.log('this.tmUserId',this.tmUserId)
      userService.FedbackReportTaskTransfer({
        taskId: this.taskId,
        toUserId: this.tmUserId,
        bizId: this.bizId,
      }).then((res) => {
        console.log("🚀 ~ file: transferUser.vue:108 ~ pickUp ~ res:", res)
        if (res.code === '200') {
          this.$message.success('转移成功')
          this.paramInfo=null
        }
        this.$emit('closeUserDialog')
      })
    },
    //页码变化
    pageNumberChange(val) {
      this.queryCondition.pageNum = val;
      this.queryData();
    },
    //显示条数变更
    pageSizeChange(val) {
      this.queryCondition.pageSize = val;
      this.queryData();
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        name: '',
        userCd: ''
      }
      this.selectDataAll = null
      this.queryData();
    },
  }
}
</script>
<style scoped>
.handle-input {
  width: 95%;
}

.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}

/*穿梭框样式重写*/
.el-transfer .el-transfer-panel {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  display: inline-block;
  vertical-align: middle;
  width: 255px;
  max-height: 100%;
  box-sizing: border-box;
  position: relative;
}

.el-transfer-panel__body {
  height: 370px;
}

.el-transfer-panel__list.is-filterable {
  height: 360px;
}
</style>
